export default class {
	constructor(obj) {
		this.id = obj.id
		this.name = obj.name
		this.comment = obj.comment
		this.logo = obj.logo
		this.url = obj.url
	}
}



// WEBPACK FOOTER //
// ./src/administration/dto/DtoSource.js